module.exports = __webpack_public_path__ + "static/img/roleInfo.d5dd636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/role/character_5/roleInfo.png
// module id = 3AIN
// module chunks = 1